module.exports = __webpack_public_path__ + "img/outsourcing.6829842a.svg";